import { ReactFragment, ReactNode } from 'react';
import { ColumnTypes, ExtendedColumnProps } from '../../../utils/dataTable/column';
import { ISectionsAccessPermissions } from '../../../slices/users/user';

export const userColumnsLight: ExtendedColumnProps<ISettingsUser>[] = [
  {
    title: 'User',
    dataIndex: 'user',
    key: 'user',
    dataType: ColumnTypes.CustomComponent,
    sorter: true,
    align: 'left',
    isDefaultColumn: true
  },
  {
    title: 'Role',
    dataIndex: 'userType',
    key: 'userType',
    dataType: ColumnTypes.String,
    sorter: true,
    align: 'left',
    isDefaultColumn: true
  },
  {
    title: 'Last login date',
    dataIndex: 'lastLogin',
    key: 'lastLogging',
    dataType: ColumnTypes.Date,
    sorter: true
  },
  {
    title: '',
    key: 'actions',
    dataType: ColumnTypes.CustomComponent,
    isActionsColumn: true
  }
];
export const userColumnsLightWithAccessColumn: ExtendedColumnProps<ISettingsUser>[] = [
  {
    title: 'User',
    dataIndex: 'user',
    key: 'user',
    dataType: ColumnTypes.CustomComponent,
    sorter: true,
    align: 'left',
    isDefaultColumn: true
  },
  {
    title: 'Role',
    dataIndex: 'userType',
    key: 'userType',
    dataType: ColumnTypes.String,
    sorter: true,
    align: 'left',
    isDefaultColumn: true
  },
  {
    title: 'Last login date',
    dataIndex: 'lastLogin',
    key: 'lastLogging',
    dataType: ColumnTypes.Date,
    sorter: true
  },
  {
    title: 'Access',
    dataIndex: 'access',
    key: 'access',
    dataType: ColumnTypes.CustomComponent,
    sorter: false,
    align: 'left'
  },
  {
    title: '',
    key: 'actions',
    dataType: ColumnTypes.CustomComponent,
    isActionsColumn: true
  }
];

export interface ISettingsUser {
  id: string;
  user: ReactFragment;
  lastLogin: ReactNode;
  userType: ReactFragment | string;
  displayActionMenu: boolean;
  accountId: string;
  // Use for Features.sectionsPermissions
  email: string;
  sectionPermissions?: ISectionsAccessPermissions;
  // End of use for Features.sectionsPermissions
}